import type {
  DocumentPageMetadataUserEditComment,
  DocumentPageMetadataUserEditEntry,
} from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'
import {
  appendPageMetadataUserEditComments,
  buildPageMetadataUserEditComment,
} from 'features/knowledgeDocumentViewer/utils/pageMetadataUserEditComments'
import { type RolodexEntryPatchJson, RolodexEntryType } from 'types'

export type DocumentPageMetadataUserEditCommentPatchData = {
  comments: DocumentPageMetadataUserEditComment[]
}

export function buildDocumentPageMetadataUserEditCommentPatch(args: {
  id: string
  comments: readonly DocumentPageMetadataUserEditComment[]
}): RolodexEntryPatchJson<DocumentPageMetadataUserEditCommentPatchData> {
  return {
    id: args.id,
    type: RolodexEntryType.DOCUMENT_PAGE_METADATA_USER_EDIT,
    data: {
      comments: [...args.comments],
    },
  }
}

/** Comment-only PATCH. Returns undefined instead of creating an event. */
export function buildAppendPageMetadataUserEditCommentPatch(args: {
  host: DocumentPageMetadataUserEditEntry | undefined
  text: string
  createdBy: string
  createdAt: string
}):
  | RolodexEntryPatchJson<DocumentPageMetadataUserEditCommentPatchData>
  | undefined {
  if (args.host === undefined) return undefined
  const comment = buildPageMetadataUserEditComment({
    text: args.text,
    createdBy: args.createdBy,
    createdAt: args.createdAt,
  })
  if (comment === undefined) return undefined
  return buildDocumentPageMetadataUserEditCommentPatch({
    id: args.host.entry.id,
    comments: appendPageMetadataUserEditComments(
      args.host.entry.data.comments,
      comment
    ),
  })
}
